import { useViewsCountStore } from '~/stores/views-count'

export default defineNuxtRouteMiddleware((to, from) => {
  if (from) useViewsCountStore().incrementViewsCount()
})
